<template>
  <v-row justify="end" class="py-1 px-2 margin-none">
    <v-col cols="12" class="align-self-center">
      <div v-if="showDesc" class="d-flex justify-end align-center">
        <div class="d-flex justify-end align-center">
          <span class="pagination-text__desc">结果：</span>
          <span class="mr-6">{{ totalSize || 0 }}</span>
          <span class="pagination-text__desc">每页：</span>
          <span>{{ pageSizeState }}</span>

          <v-menu offset-y>
            <template #activator="{ on, attrs }">
              <img
                src="@/assets/images/svg/triangle.svg"
                class="ml-2"
                v-bind="attrs"
                alt=""
                v-on="on"
              />
            </template>
            <v-list>
              <v-list-item
                v-for="(item, index) in [5, 10, 15, 20]"
                :key="index"
              >
                <v-list-item-title class="cursor" @click="pageSizeState = item">
                  {{ item }}
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </div>

        <v-pagination
          v-model="currentPageState"
          :total-visible="totalVisible"
          circle
          :length="totalPage"
          color="#F4F4F4"
        ></v-pagination>
      </div>
    </v-col>
  </v-row>
</template>
<script>
import { computed } from 'vue'

export default {
  name: 'BasePagination',
  components: {},
  props: {
    totalSize: {
      type: Number,
      default: 56,
    },
    pageSize: {
      type: Number,
      default: 10,
    },
    currentPage: {
      type: Number,
      default: 1,
    },
    // 最大可见分页数
    totalVisible: {
      type: Number,
      default: 7,
    },
    // 是否展示total和切换分页
    showDesc: {
      type: Boolean,
      default: true,
    },
  },
  emits: ['pageSizeChange', 'currentPageChange'],
  setup(props, { emit }) {
    const currentPageState = computed({
      get() {
        return props.currentPage
      },
      set(value) {
        emit('currentPageChange', value)
      },
    })
    const pageSizeState = computed({
      get() {
        return props.pageSize
      },
      set(value) {
        emit('pageSizeChange', value)
      },
    })
    const totalPage = computed(() =>
      Math.ceil(props.totalSize / pageSizeState.value)
    )
    return {
      currentPageState,
      pageSizeState,
      totalPage,
    }
  },
}
</script>

<style lang="scss" scoped>
:deep(.v-pagination__item, .v-pagination__navigation) {
  box-shadow: none;
}
</style>
